import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { Flame } from 'lucide-react';
import { useAppData } from '@/context/AppDataContext';

const UrgencyBanner = ({ settings }) => {
  if (settings && settings.urgency_banner_enabled === false) return null;
  const text = settings?.urgency_banner_text || 'OFERTAS RELAMPAGO EXPIRAM EM POUCOS MINUTOS!';

  return (
    <div className="fixed top-0 left-0 right-0 bg-[#FF4500] text-white text-center py-2 px-4 z-[60]" data-testid="urgency-banner">
      <p className="text-xs sm:text-sm font-bold animate-blink flex items-center justify-center gap-2">
        <Flame className="w-4 h-4 inline" />
        <span>{text}</span>
        <Flame className="w-4 h-4 inline" />
      </p>
    </div>
  );
};

export const Layout = ({ children }) => {
  // Usa o contexto global em vez de fazer fetch próprio
  const { settings } = useAppData();

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f8fafc' }}>
      <UrgencyBanner settings={settings} />
      <Header />
      <main className="flex-1 pt-[100px] md:pt-[116px]">
        {children}
      </main>
      <Footer settings={settings} />
      <WhatsAppButton settings={settings} />
    </div>
  );
};

export default Layout;
